import CosmosJobsDbRecordBase from '@/models/CosmosJobsDbRecordBase'
import moment from 'moment'

export default class DrainageReportModel extends CosmosJobsDbRecordBase {
  public templateId: number
  public name: string
  public htmlBody: string
  public updatedAt: moment.Moment
}
